module.exports = __webpack_public_path__ + "static/cheng-lou.49ca49a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cheng-lou.jpg
// module id = 662
// module chunks = 168707334958949